import Grid from '@mui/material/Grid2';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getTokenDetails } from '../../../store/authenticate/selectors';

const CommissionPlanSkeleton = () => {
  const tokenDetails = useAppSelector(getTokenDetails);

  return (
    <Grid container spacing={2}>
      {[...Array(3)].map((_, index) => (
        <Grid
          size={{
            xs: 12, sm: 12, md: 6, lg: 4,
          }}
          key={index?.toString()}
        >
          <Paper sx={{
            borderRadius: 2,
            ...(tokenDetails.settings.ui?.theme === 'light' && {
              bgcolor: 'background.neutral',
            }),
          }}
          >
            <Stack spacing={2.5} sx={{ p: 3, pb: 2.5 }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Skeleton animation="wave" variant="circular" width={40} height={40} />
                <Stack width="100%">
                  <Skeleton animation="wave" variant="text" width="60%" />
                  <Skeleton animation="wave" variant="text" width="40%" />
                </Stack>
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                <Skeleton animation="wave" variant="rectangular" width={80} height={30} />
                <Skeleton animation="wave" variant="rectangular" width={80} height={30} />
              </Stack>
              <Skeleton animation="wave" variant="rectangular" width="100%" height={60} />
            </Stack>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export { CommissionPlanSkeleton };
